import { type ShellStringKey } from './en.js';

/** Dutch. The `Record` annotation makes a missing or extra key a compile error. */
export const shellNl: Record<ShellStringKey, string> = {
  close: 'Sluiten',
  moreOptions: 'Meer opties',
  back: 'Terug',
  navigation: 'Onderdelen',
  newItems: '{count} nieuw',
  dismiss: 'Sluiten',
  clear: 'Wissen',
  searchMinLength: 'Typ minstens {count} tekens om te zoeken.',
  searching: 'Zoeken…',
  searchResultsOne: '1 suggestie',
  searchResultsMany: '{count} suggesties',
  searchFailed: 'Het zoeken lukte niet. Probeer het opnieuw.',
  done: 'Klaar',
  gameMenu: 'Spelmenu',
  seatYou: 'Jij',
  seatBot: 'Bot',
  seatReady: 'Klaar',
  seatNotReady: 'Nog niet klaar',
  paste: 'Plakken',
  build: 'Build {id}',
  // Home's invites (polish lane, 1.2.0).
  invitesMore: '+{count} meer',
  // Matchmaking (1.2.0).
  searchElapsed: 'Zoektijd',
  // The accent lane (1.2.0): AccentPicker.
  accentLabel: 'Accentkleur',
  accentCustom: 'Eigen kleur',
  accentHue: 'Tint',
  accentVividness: 'Felheid',
  accentAdjusted: 'Aangepast zodat hij leesbaar blijft op deze achtergrond.',
  accentPreviewAction: 'Spelen',
  accentPreviewToggle: 'Aan',
  huePink: 'roze',
  hueRed: 'rood',
  hueOrange: 'oranje',
  hueYellow: 'geel',
  hueGreen: 'groen',
  hueTeal: 'blauwgroen',
  hueBlue: 'blauw',
  huePurple: 'paars',
  // The profile (TwinTen ADR 0073).
  profileEdit: 'Profiel bewerken',
  profilePicture: 'Profielfoto',
  profileAddPicture: 'Foto toevoegen',
  profileChangePicture: 'Foto wijzigen',
  profileRemovePicture: 'Verwijderen',
  profileSlogan: 'Slogan',
  profileCount: '{count}/{max}',
  profileSex: 'Geslacht',
  profileBirthYear: 'Geboortejaar',
  profileNotShown: 'Niet tonen',
  profileNote: 'Vrienden zien dit allemaal. Alle anderen zien je naam en foto.',
  profileLoading: 'Laden…',
  lobbyCodePending: 'Wachten op de code…',
  // 1.5.0 (shell-150 lane).
  profileSexOther: 'In je eigen woorden',
  // 1.7.0: samen spelen op één apparaat.
  handOffTitle: '{name} is aan de beurt',
  handOffReady: 'Ik ben {name}',
  standingsWinner: 'Winnaar',
  standingsRank: 'Plaats {rank}',
  standingsTied: 'Gedeelde plaats {rank}',
  playerNamesLabel: 'Spelers',
  playerNamesDefault: 'Speler {n}',
  playerNamesAdd: 'Speler toevoegen',
  playerNamesRemove: '{name} verwijderen',
  playerNamesDuplicate: 'Een andere speler heeft al deze naam.',
  choiceRight: 'Juist antwoord',
  choiceWrong: 'Fout antwoord',
  gamePads: 'Bediening van speler {n}',
};
